import React, { PropsWithChildren, createContext } from 'react';
import { ExternalLinksPreference } from './types';
import { DocumentPath } from '../DocumentationButton/types';

type ExternalLinkContextValue = {
  preference: ExternalLinksPreference | null;
  setPreference: (value: ExternalLinksPreference) => void;
  url: string | null;
  tooltip: string | null;
  preferenceKey: keyof typeof DocumentPath | null;
};

const defaultContextValue: ExternalLinkContextValue = {
  preference: null,
  setPreference: () => {},
  url: null,
  tooltip: null,
  preferenceKey: null,
};

const ExternalLinkContext = createContext<ExternalLinkContextValue>(defaultContextValue);
export const ExternalLinkProvider = ({
  children,
  value,
}: PropsWithChildren<{ value: ExternalLinkContextValue }>) => {
  return <ExternalLinkContext.Provider value={value}>{children}</ExternalLinkContext.Provider>;
};

export const useExternalLinkContext = () => {
  const context = React.useContext(ExternalLinkContext);
  if (!context) {
    console.warn('Cannot find ExternalLinkContext');
  }
  return context;
};
